import React from 'react';
import { calculatePasswordStrength, getPasswordStrengthMessage } from '../../utils/authUtils';

const PasswordStrengthIndicator = ({ password, className = '' }) => {
  if (!password) return null;

  const strength = calculatePasswordStrength(password);
  const strengthInfo = getPasswordStrengthMessage(password);

  return (
    <div className={`mt-2 ${className}`}>
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs font-medium text-gray-700">Fuerza de la contraseña</span>
        <span className={`text-xs font-medium ${strengthInfo.color}`}>{strengthInfo.message}</span>
      </div>

      <div className="w-full bg-gray-200 rounded-full h-2">
        <div
          className={`h-2 rounded-full transition-all duration-300 ${
            strength < 30
              ? 'bg-red-500'
              : strength < 50
                ? 'bg-orange-500'
                : strength < 70
                  ? 'bg-yellow-500'
                  : strength < 90
                    ? 'bg-blue-500'
                    : 'bg-green-500'
          }`}
          style={{ width: `${strength}%` }}
        />
      </div>

      <div className="text-xs text-gray-500 mt-1">{strength}% de fuerza</div>
    </div>
  );
};

export default PasswordStrengthIndicator;
